module.exports = __webpack_public_path__ + "images/icons/icon-card-expanded-456033d2.svg";